import React from "react";
import { useHistory  } from "react-router-dom";

export const BackButton = (props) => {
  let history = useHistory();

  const handleClick = () => {
    history.push("/home");
  }
  return (
      <>
        <button onClick={handleClick} className="back-button"><i className="fa fa-angle-left"></i></button> 
      </>
  );
};
